module.exports = __webpack_public_path__ + "static/media/robin-powered.eb36df86.svg";